import{useTabState as t,Tab as e,TabList as r,TabPanel as s}from"@twilio-paste/reakit-library";export{e as TabPrimitive,r as TabPrimitiveList,s as TabPrimitivePanel,t as useTabPrimitiveState};
